import { EWindowSizes } from '../utils/enum';

const GlobalTheme = {
  display: {
    mobile: '1440px',
    tablet: '744px',
    desktops: '375px',
  },
  breakpoints: {
    xs: EWindowSizes.XSMALL,
    sm: EWindowSizes.SMALL,
    md: EWindowSizes.MEDIUM,
    lg: EWindowSizes.LARGE,
    xl: EWindowSizes.XLARGE,
    xxl: EWindowSizes.XXLARGE,
  },
};

export type AppTheme = typeof GlobalTheme;
export default GlobalTheme;
